import { z } from 'zod';
import { AiAssistantUsage } from '@/common/graphql';

export const aiAssistantConfigSchema = z.object({
  usage: z.nativeEnum(AiAssistantUsage),
  name: z.string().min(1, 'Name is required'),
  modelId: z.string().min(1, 'Model ID is required'),
  description: z.string().min(1, 'Description is required'),
  systemInstruction: z.string().min(1, 'System instruction is required'),
});

export type AIAssistantConfigFormData = z.infer<typeof aiAssistantConfigSchema>;
